import { combineReducers } from 'redux';
import { EventVideoViewModel } from 'stageclip-common';

import { AllActions } from '../actions/allActions';
import { InternalActionTypes } from '../constants/actionTypes';
import { ById } from '../store/normalizedState';

import * as ReducerHelper from './reducerHelper';

function allIdsReducer(state: string[] = [], action: AllActions): string[] {
  switch (action.type) {
    case InternalActionTypes.EventVideosLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.eventVideos);
    case InternalActionTypes.EventVideoLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.eventVideos);
    default:
      return state;
  }
}

function byIdReducer(state: ById<EventVideoViewModel> = {}, action: AllActions): ById<EventVideoViewModel> {
  switch (action.type) {
    case InternalActionTypes.EventVideosLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.eventVideos);
    case InternalActionTypes.EventVideoLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.eventVideos);
    default:
      return state;
  }
}

export const eventVideosReducer = combineReducers({
  allIds: allIdsReducer,
  byId: byIdReducer,
});
